import { useForm } from '@/common/form/FormContext';
import { EnumSelect } from '@/common/form/formFields/EnumSelect';
import { useEffect } from 'react';

export const PolPeriodicitySelect = ({ fieldDef, polTypeToPeriodicity }) => {
  const { formValues, assignValue } = useForm();

  const updatedFieldDef = {
    ...fieldDef,
    disabled: fieldDef.disabled || formValues.type !== 'BUNDLE',
    values: fieldDef.values.filter((enumSpec) => enumSpec.code !== 'DAY'),
  };

  useEffect(() => {
    if (fieldDef.disabled) return;
    if (formValues.type === undefined) return;
    if (formValues.type === 'BUNDLE') return; // If type is BUNDLE, leave the value as is

    const polType = formValues.type;
    const periodicity = polTypeToPeriodicity[polType];
    assignValue('periodicity', periodicity);
  }, [formValues.type]);

  return <EnumSelect fieldDef={updatedFieldDef} />;
};
